<template>
  <div>
    <LDBsTable
      ref="table"
      url="integrator/install-instructions"
      defaultSort="createdAt"
      defaultOrder="desc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
      :loadOnMount="false"
      startSearchOpen
    >
      <div class="form-group col-lg-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :getOptionLabel="(client) => client.CLI_ID + ' - ' + client.CLI_DSC"
          :options="arenaClients"
          v-model="queryToUse.client"
          :initial-value="queryToUse.client"
          :reduce="(client) => client.CLI_ID"
        />
      </div>
    </LDBsTable>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from "vuex";

export default {
  name: "IntegratorInstallInstructionsListComponent",
  components: {
    LoaderButton,
    Combobox,
    LDBsTable,
  },

  data() {
    return {
      clientSelected: null,
      errorsMessage: [],
      columns: [
        {
          title: this.$t("client"),
          field: "client",
          sortable: false,
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value) {
            return `<a href="#/main/integrador/integrator-install-instructions/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "integrador-instrucoes-instalacao" },
      },
      query: {
        client: undefined,
      },
      queryToUse: {},
    };
  },

  computed: {
    ...mapState({
      arenaClients: (state) => state.arena.clients,
      lastquery: (state) => state.filtershistory.query,
    }),
  },

  methods: {
    clear() {
      this.query = {
        client: undefined,
      };
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery["integratorinstallinstructionslist"]
      ? this.lastquery["integratorinstallinstructionslist"]
      : this.query;
  },

  async mounted() {
    const { dispatch } = this.$store;

    if (this.lastquery["integratorinstallinstructionslist"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["integratorinstallinstructionslist"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    await Promise.all([dispatch("arena/fetchClients")]);
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "integratorinstallinstructionslist",
      query: this.query,
    });
  },
};
</script>
